<template>
<!-- TODO настроить transition  -->
<!--  <transition name="fade">-->
    <div
      class="modal"
      :class="[activeClass, alignClass]"
    >
      <div
        class="modal__wrap"
        @mousedown.self="onClose"
      >
        <div class="modal__content">
          <button
            v-if="!hiddenCloseBtn"
            class="btn-reset btn-cross btn-cross--modal"
            @click="onClose"
          />

          <h4 v-if="title" class="modal__title">
            {{ title }}
            <span v-if="subtitle" class="modal__subtitle">
              {{ subtitle }}
            </span>
            <span v-if="counter" class="counter" :class="'bg-color--red'">
              {{ counter }}
            </span>
          </h4>

          <slot />
        </div>
      </div>
    </div>
<!--  </transition>-->
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    hiddenCloseBtn: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'center',
      validator: value => ['center', 'right'].includes(value)
    },
    counter: {
      type: [String, Number],
      default: null
    },
    subtitle: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    activeClass: ''
  }),

  computed: {
    alignClass () {
      return `modal--${this.align}` // modal--center или modal--right
    }
  },

  mounted () {
    this.activeClass = 'modal--active'
  },

  destroyed () {
    this.activeClass = ''
  },

  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>
